

import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import PageTopTitle from "../../shared/PageTopTitle"
import { showModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import Btn from "../../shared/button/Btn"
import InputSelect from "../../shared/input/new/InputSelect"
import InputText from "../../shared/input/new/InputText"
import SmallSpinner from "../../shared/spinners/SmallSpinner"
import { addYukbulBlockingMessage, getYukbulMessages, getYukbulMessagesCount, setYukbulMessages } from "../../../features/admin5/admin5Slice"
import moment from "moment"

const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: auto;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            height: auto;
            min-height: 300px;
            max-height: 600px;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 40px 60px;
            margin: 20px 0;
            width: 1100px;
            gap: 40px;
            overflow: auto;
            
            &::-webkit-scrollbar {
                width: 0;
                width: 4px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: #9e9b9b;
                border-radius: 6px;
            }
            &::-webkit-scrollbar-track {
                background-color: transparent;
            }

            .btn-grp{
                width: 100%;
                display: flex;
                justify-content: center;
                gap: 60px;

            }

            .desc{
                color: ${({theme}) => theme.mainTextColor};
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }

            .deleted-container{
                display: flex;
                flex-direction: column;
                width: 100%;

                .deleted-container-top{
                    width: 100%;
                    padding-bottom: 5px;
                    border-bottom: 1px solid ${({theme}) => theme.mainTextColor};
                    margin-bottom: 8px;
                    h3{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-lg);
                        color: var(--color-main);
                    }
                }

                .deleted-message-list{
                    display: flex;
                    flex-direction: column;
                    gap: 20px;


                    .deleted-message-item{
                        background-color: ${({theme}) => theme.secondaryBgColor};
                        color: ${({theme}) => theme.mainTextColor};
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                        padding: 20px;
                        border-radius: 10px;

                        .deleted-message-item-top{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            color: var(--color-main);
                            font-weight: var(--font-weight-lg);
                            padding-bottom: 10px;
                            border-bottom: px solid var(--color-main);
                        }
                    }
                }
            }
        }

   

        .error-container{
            margin-bottom: 20px;
            .error{
                color: var(--color-main);
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-md);
            }
        }

        .button-grp{
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            width: 640px;
            border-top: 1px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
            margin-right: 8px;
        }
    }
`

const blockTypeOptions = [
    {
      value: 1,
      text: "Yazı Engelle"
    },
    {
      value: 2,
      text: "Telefon Numarasına Ait Mesajları Engelle"
    },
  ]

  const formatData = (data) => {
    return data
        .split("\r\n") // Satırları ayır
        .map(line => line.trim()) // Boşlukları temizle
        .filter(line => line && line !== "_________") // Boş satırları ve gereksiz çizgileri çıkar
        .map((line, index) => <p key={index}>{line}</p>); // JSX içine çevir
};

const AddYukBulBlockingMessageModal = () => {
    
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const {
        isLoadingAddYukbulBlockingMessage,
        allYukbulMessages,
        allYukbulMessagesCount
    } = useSelector(state => state.admin5)
    const { lockScroll, unlockScroll } = useScrollLock();

    const [blockText, setBlockText] = useState("")
    const [blockType, setBlockType] = useState({
        value: "",
        text: ""
    })

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    useEffect(() => {
        if(blockText.length >= 3 && blockType.value){
                dispatch(getYukbulMessagesCount({
                    filterText: blockType.value === 1 ? blockText : "",
                    phoneNumber: blockType.value === 2 ? blockText : "",
                }))
        }
    },[blockText, blockType.value])

    useEffect(() => {
        setBlockText("")
    },[blockType.value])
    
    useEffect(() => {
            dispatch(setYukbulMessages([]))
    },[blockType.value, blockText])

    const handleSubmit = () => {
        if(blockText && blockType.value){
            dispatch(addYukbulBlockingMessage({
                filterType: blockType.value,
                FilterValue: blockText
            }))
        }
    }

 
  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))} >
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <PageTopTitle title={"Mesaj Engelle"}/>
            <div className="content">
                <div className="btn-grp">
                    <InputSelect data={blockType.text} setData={setBlockType} initialOptions={blockTypeOptions} labelText={"Engel Türü"} inputWidth={"320px"} name={"addYukBulFilterType"}/>
                    <InputText data={blockText} setData={(e) => setBlockText(blockType.value === 2 ? e.target.value.replace(/[^0-9]/g, '').replace(/^0/, "") : e.target.value)} labelText={`Engellenecek ${blockType.value === 0 ? "" : blockType.value === 1 ? " Yazı" : " Telefon Numarası"}`} inputWidth={"320px"}/>
                </div>
                {
                    blockType.value && blockText &&
                    <p className="desc">
                        {
                            blockType.value === 1 ? `Onayladığınız halde "${blockText}" yazısı içeren mesajlar engellenecektir.`: `Onayladığınız halde "${blockText}" telefon numarasının yazmış olduğu mesajlar engellenecektir.`
                        }
                    </p>
                }

                {
                    (allYukbulMessagesCount > 0 && blockText) &&

                    <div className="deleted-container">
                        <div className="deleted-container-top">
                            <h3>Silinecek Mesajlar ({allYukbulMessagesCount}) <button onClick={() =>  dispatch(getYukbulMessages({
                    filterText: blockType.value === 1 ? blockText : "",
                    phoneNumber: blockType.value === 2 ? blockText : "",
                    from:"block"
                }))}>Görüntüle</button></h3>
                        </div>
                        <div className="deleted-message-list">
                            {
                                allYukbulMessages.map(item => (
                                    <div className="deleted-message-item">
                                        <div className="deleted-message-item-top">
                                            <div className="date">{moment(item.messageSentTime).format('LLL')}</div>
                                            <div className="date">{item.phoneNumber}</div>
                                        </div>
                                        <div className="message">{formatData(item.message)}</div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                }
                
           </div>
            <div className='button-grp'>
                <Btn bgColor="#E85446" color="#fff" handleClick={handleSubmit} width={"220px"}>{isLoadingAddYukbulBlockingMessage ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Onayla ve Engelle"}</Btn>
                <Btn color="#E85446" bgColor="transparent" width={"220px"} handleClick={()=> dispatch(showModal(null))}>Geri Dön</Btn>
            </div>
        </div>
    </ModalContainer>
  )
}

export default AddYukBulBlockingMessageModal